import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { toast } from 'react-toastify';

interface CopyableInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
  icon: React.ElementType;
  required?: boolean;
  placeholder?: string;
  type?: string;
  className?: string;
  options?: { value: string; label: string; }[] | null;
  disabled?: boolean;
}

const CopyableInput: React.FC<CopyableInputProps> = ({
  value,
  onChange,
  name,
  label,
  icon: Icon,
  required = false,
  placeholder = '',
  type = 'text',
  className = '',
  options = null,
  disabled = false
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      toast.success('Testo copiato negli appunti');
    }
  };

  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center">
        <Icon className="h-4 w-4 mr-1.5 text-gray-400" />
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative">
        {options ? (
          <select
            name={name}
            value={value}
            onChange={onChange}
            className={`w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent ${
              disabled ? 'bg-gray-100 cursor-not-allowed' : ''
            }`}
            required={required}
            disabled={disabled}
          >
            <option value="">{placeholder || `Seleziona ${label.toLowerCase()}`}</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : (
          <>
            <input
              type={type}
              name={name}
              value={value}
              onChange={onChange}
              className={`w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 focus:ring-2 focus:ring-primary focus:border-transparent ${
                disabled ? 'bg-gray-100 cursor-not-allowed' : ''
              }`}
              placeholder={placeholder}
              required={required}
              disabled={disabled}
            />
            <button
              type="button"
              onClick={handleCopy}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition-colors"
              title="Copia testo"
            >
              {copied ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CopyableInput;